<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <WinesForm :baseWine="wine" :baseWineName="name" :loading="loading" @submit-requested="submitRequested"></WinesForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import WinesForm from './WinesForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            wine: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { WinesForm },
    computed:
    {
        ...mapState('wines', ['getWineDetailsOutput']),
    },
    methods: {
        ...mapActions('wines', ['getWineDetails']),
        ...mapActions('wines', ['putWine']),
        submitRequested(wine) {
            this.putWine(wine);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'WinesList' });
        }

        this.getWineDetails(this.$route.query.id);
    },
    watch:
    {
        getWineDetailsOutput: function(wineOutput)
        {
            if(!wineOutput && !wineOutput.data)
            {
                router.push({ name: 'WinesList' });
            }
            else
            {
                this.wine = wineOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>